import { Component, OnInit, ViewChild } from '@angular/core';
import { Permission } from '../models/permission.model';
import { AlertService, MessageSeverity } from '../services/alert.service';
import { DisplayModes } from '../models/enums';
import { ModalDirective } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { AppTranslationService } from '../services/app-translation.service';
import { AppConfigService } from '../app.config';
import { AccountService } from '../services/account.service';
import { SurveyService } from './survey.service';
import { HelperMethodsService } from '../services/helper-methods.service';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'


@Component({
  selector: 'crm-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit {

  surveys: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  public logo = "";

  selectedSurveyId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;

  @ViewChild('applyModal')
  applyModal: ModalDirective;
  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly surveysService: SurveyService, private readonly helperMethods: HelperMethodsService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getSurveys();
  }

  getSurveys() {
    this.displayMode = DisplayModes.Loading;
    this.surveysService.search(this.searchText).subscribe(responce => {
      this.surveys = responce as any[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get item surveys');
        console.log(err);
      })

  }

  gotoNew() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedSurveyId = id;
    this.addNew = true;
  }

  confirmDelete(survey) {
    this.selectedSurveyId = survey;
    this.deleteModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.surveysService.delete(this.selectedSurveyId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);

      let index = this.surveys.indexOf(this.selectedSurveyId);
      this.surveys.splice(index, 1);
      this.selectedSurveyId = undefined;
    }, error => {
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while delete survey:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  get canEditSurveys() {
    return this.accountService.userHasPermission(Permission.editSurveyPermission);
  }

  get canDeleteSurveys() {
    return this.accountService.userHasPermission(Permission.deleteSurveyPermission);
  }

  get canInitiateSurveys() {
    return this.accountService.userHasPermission(Permission.initiateSurveyPermission);
  }

  get canTrackSurveys() {
    return this.accountService.userHasPermission(Permission.trackSurveyPermission);
  }


  closeAdding(event) {
    this.selectedSurveyId = undefined;
    this.addNew = false;
    if (event) {
      this.getSurveys();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  canEdit(endDate) {
    let today = this.helperMethods.getDateUTC(new Date())
    return today < new Date(endDate);
  }

  canApply(endDate) {
    let today = this.helperMethods.getDateUTC(new Date())
    return today >= new Date(endDate);
  }

  confirmApply(id) {
    this.selectedSurveyId = id;
    this.applyModal.show();
  }

  apply() {
    this.hideApplyModal();
    
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Applying"));
    this.surveysService.applySurvey(this.selectedSurveyId).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.stopLoadingMessage();
      this.selectedSurveyId = undefined;
      if (response && response == true) {
        this.displayMode = DisplayModes.Success;
        this.alertService.showMessage("", this.translateService.getTranslation("Applying Succefully"), MessageSeverity.Success);
        this.getSurveys();
      }
      else {
        this.alertService.showStickyMessage("Save Error", "The below errors occured while apply survey:", MessageSeverity.Error);
      }

    }, error => {
      
      this.alertService.stopLoadingMessage();
      this.selectedSurveyId = undefined;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while apply survey:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  export(id) {
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Downloading"));
    this.surveysService.getSurveyResultDetails(id).subscribe(response => {
     
      if (response) {
       
        let res = response as any

        let csvOptions = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'Survey Report :',
          useBom: true,
          noDownload: false,
          headers: ['User Name', 'Territory Name', 'Id','Name','Creation Date','Old Class Name','New Class Name']
        };
         
        if (res.questions) {
          res.questions.forEach(q => { csvOptions.headers.push(q.title) })
          if (res.details) {
            let f: any = [];
            res.details.forEach(x => {
              let item: any = {};
              item.userName = x.userName;
              item.territoryName = x.territoryName;
              item.hcoHcpId = x.hcoHcpId;
              item.hcoHcpName = x.hcoHcpName;
              item.creationDate = x.creationDate;
              item.oldClassName = x.oldClassName;
              item.newClassName = x.newClassName;
              
              item.questions = [];
              res.questions.forEach(y => {
                let r = x.surveyResultDetails.filter(x => x.surveyQuestionId == y.id);
                if (r && r[0])
                  item.questions.push(r[0].score)
                else
                  item.questions.push(0);
              })
              f.push(item);
            });
            const csvData = f;
            new AngularCsv(csvData, "Survey Report", csvOptions);
          }
        }
        this.alertService.stopLoadingMessage();
        this.alertService.showMessage("", this.translateService.getTranslation("Downloading Succefully"), MessageSeverity.Success);
      }
      else {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage("Save Error", "The below errors occured while download survey result", MessageSeverity.Error);
      }

    }, error => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while download survey result:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  hideApplyModal() {
    this.applyModal.hide();
  }
}
